import { UIComponentViewImpl } from '../uicomponentview';
import { UIComponentState } from '../uicomponent';
import { CarouselCSSStyle } from './carouselcss';
import * as React from 'react';
import './carousel.css';
import { CarouselComponentProps } from './carouselcomponent';

export class CarouselViewImpl<T> extends UIComponentViewImpl<T>
{
    draw(props: CarouselComponentProps<T>, state: UIComponentState, cssStyle: CarouselCSSStyle): JSX.Element | boolean
    {
        super.draw(props, state, cssStyle);

        return (
            <>
            <div style={{ position: "relative",display: "flex", justifyContent: "center", alignItems: "center", margin:0, padding: "0 0px"}}>
             <div className={"swiper-container " + props.id}>
                <div className="swiper-wrapper">
                {
                    props.listViewModel.getListOfDatas().map((entry, index)=>
                    {
                        return props.listViewModel.getView(entry, index);
                    }
                )
                }
                </div>
                    <div className="swiper-pagination"/>
                </div>
                    <img id={props.id} src={require("./previous.svg")} style={cssStyle.getArrowsCSSStyle(props.carouselType, "left")} className="swiper-button-prev"/>
                    <img id={props.id} src={require("./next.svg")} style={cssStyle.getArrowsCSSStyle(props.carouselType, "right")} className="swiper-button-next"/>
                </div>
            </>);
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/toolkit/carousel/carouselview.tsx